import { render, staticRenderFns } from "./TwofactorEditComponent.vue?vue&type=template&id=4e0b4085"
import script from "./TwofactorEditComponent.vue?vue&type=script&lang=js"
export * from "./TwofactorEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports